export const GET_SHIPMENT_LABEL_SUCCESS = "GET_SHIPMENT_LABEL_SUCCESS";
export const GET_SHIPMENT_LABEL_REQUEST = "GET_SHIPMENT_LABEL_REQUEST";
export const GET_SHIPMENT_LABEL_FAILURE = "GET_SHIPMENT_LABEL_FAILURE";
export const getShipmentLabelSuccess = (payload) => ({
    type: GET_SHIPMENT_LABEL_SUCCESS,
    payload,
});
export const getShipmentLabelRequest = () => ({
    type: GET_SHIPMENT_LABEL_REQUEST,
});
export const getShipmentLabelFailure = (payload) => ({
    type: GET_SHIPMENT_LABEL_FAILURE,
    payload,
});
